exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{display:block;text-align:center}:host-context(.gh-grid-narrow-theme){line-height:20px}", ""]);

// exports
